interface Props {
  emetteurLogo?: string | null;
  emetteur?: string;
  emetteurPoste?: string | null;
  emetteurEntreprise?: string | null;
}

export function MailSignature({
  emetteurLogo,
  emetteur,
  emetteurPoste,
  emetteurEntreprise,
}: Props) {
  // Utilise les métadonnées du mail si fournies, sinon repli sur les props individuelles
  const logo = emetteurLogo ?? null;
  const name = emetteur ?? "";
  const position = emetteurPoste ?? null;
  const company = emetteurEntreprise ?? null;
  return (
    <div className="mb-6">
      <div className="mt-6 flex items-center space-x-4">
        {logo && (
          <img src={logo} alt="Logo" className="h-12 w-auto object-contain" />
        )}
        <div className="italic">
          <div>{name}</div>
          <div>
            {position}
            {company && position && ", "}
            {company && company}
          </div>
        </div>
      </div>
    </div>
  );
}
